'use client';

import React, { createContext, useContext, useState } from 'react';

interface IsDataAvailableContextType {
  isDataAvailable: boolean;
  setIsDataAvailable: (value: boolean) => void;
}

const IsDataAvailableContext = createContext<IsDataAvailableContextType>({
  isDataAvailable: true,
  setIsDataAvailable: () => {},
});

export const useIsDataAvailable = () => useContext(IsDataAvailableContext).isDataAvailable;
export const useSetIsDataAvailable = () => useContext(IsDataAvailableContext).setIsDataAvailable;

interface IsDataAvailableProviderProps {
  children: React.ReactNode;
  initialIsDataAvailable?: boolean;
}

export const IsDataAvailableProvider: React.FC<IsDataAvailableProviderProps> = ({
  children,
  initialIsDataAvailable = true,
}) => {
  const [isDataAvailable, setIsDataAvailable] = useState<boolean>(initialIsDataAvailable);
  return (
    <IsDataAvailableContext.Provider value={{ isDataAvailable, setIsDataAvailable }}>
      {children}
    </IsDataAvailableContext.Provider>
  );
};

export default IsDataAvailableContext;
